/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BoxAiLogo = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            d="M25.191 14.036c1.668-2.387 2.19-4.466 1.432-5.538l.001-.002c-.618-.873-2.146-1.169-4.207-.832a19.527 19.527 0 00-.669-1.905c3.068-.578 5.37-.019 6.505 1.587 1.175 1.662.873 4.13-.85 6.948-.264.43-.559.862-.877 1.294a24.71 24.71 0 00-1.335-1.552z"
            fill={vars.bdlLightBlue}
        />
        <path
            d="M25.191 14.036c1.668-2.387 2.19-4.466 1.432-5.538l.001-.002c-.618-.873-2.146-1.169-4.207-.832a19.527 19.527 0 00-.669-1.905c3.068-.578 5.37-.019 6.505 1.587 1.175 1.662.873 4.13-.85 6.948-.264.43-.559.862-.877 1.294a24.71 24.71 0 00-1.335-1.552z"
            fill="url(#prefix__BoxAILogo__a)"
            fillOpacity={0.2}
        />
        <path
            d="M19.53 8.44c-.271.099-.547.203-.827.317a32.238 32.238 0 00-2.143-1.224 25.02 25.02 0 012.288-.961 16.254 16.254 0 01.683 1.87z"
            fill={vars.bdlLightBlue}
        />
        <path
            d="M19.53 8.44c-.271.099-.547.203-.827.317a32.238 32.238 0 00-2.143-1.224 25.02 25.02 0 012.288-.961 16.254 16.254 0 01.683 1.87z"
            fill="url(#prefix__BoxAILogo__b)"
            fillOpacity={0.2}
        />
        <path
            d="M13.094 11.885a31.26 31.26 0 012.395-1.537 24.958 24.958 0 00-2.144-1.03c-.441.28-.88.573-1.316.878a26.69 26.69 0 00-.423 2.807c.473-.376.968-.75 1.489-1.118h-.001z"
            fill={vars.bdlLightBlue}
        />
        <path
            d="M13.094 11.885a31.26 31.26 0 012.395-1.537 24.958 24.958 0 00-2.144-1.03c-.441.28-.88.573-1.316.878a26.69 26.69 0 00-.423 2.807c.473-.376.968-.75 1.489-1.118h-.001z"
            fill="url(#prefix__BoxAILogo__c)"
            fillOpacity={0.2}
        />
        <path
            d="M23.276 16.366l.25.284h.002c.368.423.709.846 1.019 1.269a29.078 29.078 0 01-1.7 1.626 33.089 33.089 0 01-2.28 1.834l-.113.082a35.926 35.926 0 01-.48.343 34.897 34.897 0 01-1.832 1.199 30.514 30.514 0 01-2.7 1.464 25.59 25.59 0 01-2.762 1.127c-.657.221-1.303.403-1.93.542l-.084.02-.085.019-.03.006-.297.059c-3.067.578-5.37.018-6.505-1.587-1.174-1.662-.872-4.13.851-6.949a18.72 18.72 0 011.188-1.705 23.531 23.531 0 011.668-1.918c.367-.38.749-.757 1.15-1.13a33.669 33.669 0 00-.13 2.399c-.004.187-.006.374-.006.56l-.027.03a20.508 20.508 0 00-1.633 2.025c-1.667 2.388-2.19 4.466-1.432 5.539.618.873 2.147 1.169 4.208.832a12.7 12.7 0 00.493-.091 16.26 16.26 0 001.92-.521 22.563 22.563 0 001.86-.72 25.996 25.996 0 002.653-1.351 31.247 31.247 0 003.884-2.655 27.763 27.763 0 002.631-2.373c.084-.086.168-.172.249-.259z"
            fill={vars.bdlLightBlue}
        />
        <path
            d="M23.276 16.366l.25.284h.002c.368.423.709.846 1.019 1.269a29.078 29.078 0 01-1.7 1.626 33.089 33.089 0 01-2.28 1.834l-.113.082a35.926 35.926 0 01-.48.343 34.897 34.897 0 01-1.832 1.199 30.514 30.514 0 01-2.7 1.464 25.59 25.59 0 01-2.762 1.127c-.657.221-1.303.403-1.93.542l-.084.02-.085.019-.03.006-.297.059c-3.067.578-5.37.018-6.505-1.587-1.174-1.662-.872-4.13.851-6.949a18.72 18.72 0 011.188-1.705 23.531 23.531 0 011.668-1.918c.367-.38.749-.757 1.15-1.13a33.669 33.669 0 00-.13 2.399c-.004.187-.006.374-.006.56l-.027.03a20.508 20.508 0 00-1.633 2.025c-1.667 2.388-2.19 4.466-1.432 5.539.618.873 2.147 1.169 4.208.832a12.7 12.7 0 00.493-.091 16.26 16.26 0 001.92-.521 22.563 22.563 0 001.86-.72 25.996 25.996 0 002.653-1.351 31.247 31.247 0 003.884-2.655 27.763 27.763 0 002.631-2.373c.084-.086.168-.172.249-.259z"
            fill="url(#prefix__BoxAILogo__d)"
            fillOpacity={0.2}
        />
        <path
            d="M22.06 8.237a18.807 18.807 0 00-.81-2.373l-.033-.08a6.229 6.229 0 00-.17-.387C19.751 2.56 17.967 1 16.001 1c-1.966 0-3.752 1.559-5.05 4.398a13.813 13.813 0 00-.173.394l-.03.073a19.159 19.159 0 00-.81 2.373 26.377 26.377 0 00-.697 3.482 31.884 31.884 0 00-.27 3.656v.004c-.003.172-.005.344-.005.517v.21a33.107 33.107 0 00.276 4.177c.162 1.225.397 2.393.697 3.482.087-.017.173-.034.262-.054.537-.12 1.091-.276 1.657-.465a22.259 22.259 0 01-.426-1.866 27.684 27.684 0 01-.418-3.52 32.547 32.547 0 010-3.719 28.182 28.182 0 01.563-4.24 21.94 21.94 0 01.419-1.623 16.33 16.33 0 01.893-2.327c.915-1.878 2.04-2.954 3.109-2.954 1.07 0 2.194 1.076 3.109 2.954A16.455 16.455 0 0120 8.278a20.861 20.861 0 01.419 1.625c.818.58 1.599 1.189 2.336 1.817a26.23 26.23 0 00-.698-3.482l.003-.001z"
            fill="#FF00DB"
        />
        <path
            d="M22.06 8.237a18.807 18.807 0 00-.81-2.373l-.033-.08a6.229 6.229 0 00-.17-.387C19.751 2.56 17.967 1 16.001 1c-1.966 0-3.752 1.559-5.05 4.398a13.813 13.813 0 00-.173.394l-.03.073a19.159 19.159 0 00-.81 2.373 26.377 26.377 0 00-.697 3.482 31.884 31.884 0 00-.27 3.656v.004c-.003.172-.005.344-.005.517v.21a33.107 33.107 0 00.276 4.177c.162 1.225.397 2.393.697 3.482.087-.017.173-.034.262-.054.537-.12 1.091-.276 1.657-.465a22.259 22.259 0 01-.426-1.866 27.684 27.684 0 01-.418-3.52 32.547 32.547 0 010-3.719 28.182 28.182 0 01.563-4.24 21.94 21.94 0 01.419-1.623 16.33 16.33 0 01.893-2.327c.915-1.878 2.04-2.954 3.109-2.954 1.07 0 2.194 1.076 3.109 2.954A16.455 16.455 0 0120 8.278a20.861 20.861 0 01.419 1.625c.818.58 1.599 1.189 2.336 1.817a26.23 26.23 0 00-.698-3.482l.003-.001z"
            fill="url(#prefix__BoxAILogo__e)"
            fillOpacity={0.2}
        />
        <path
            d="M20.986 17.86A26.827 26.827 0 0022.938 16a26.286 26.286 0 00-1.952-1.86 32.666 32.666 0 01-.001 3.72h.001z"
            fill="#FF00DB"
        />
        <path
            d="M20.986 17.86A26.827 26.827 0 0022.938 16a26.286 26.286 0 00-1.952-1.86 32.666 32.666 0 01-.001 3.72h.001z"
            fill="url(#prefix__BoxAILogo__f)"
            fillOpacity={0.2}
        />
        <path
            d="M20.422 22.1c-.087.396-.18.778-.282 1.145a16.3 16.3 0 001.92.52 26.2 26.2 0 00.697-3.483 33.44 33.44 0 01-2.335 1.818z"
            fill="#FF00DB"
        />
        <path
            d="M20.422 22.1c-.087.396-.18.778-.282 1.145a16.3 16.3 0 001.92.52 26.2 26.2 0 00.697-3.483 33.44 33.44 0 01-2.335 1.818z"
            fill="url(#prefix__BoxAILogo__g)"
            fillOpacity={0.2}
        />
        <path
            d="M12.892 26.05c.915 1.879 2.039 2.955 3.109 2.955h.002c1.07 0 2.194-1.076 3.109-2.955.66.224 1.308.407 1.94.552-1.299 2.84-3.083 4.398-5.05 4.398-1.967 0-3.752-1.559-5.05-4.398a19.43 19.43 0 001.94-.552z"
            fill="#FF00DB"
        />
        <path
            d="M12.892 26.05c.915 1.879 2.039 2.955 3.109 2.955h.002c1.07 0 2.194-1.076 3.109-2.955.66.224 1.308.407 1.94.552-1.299 2.84-3.083 4.398-5.05 4.398-1.967 0-3.752-1.559-5.05-4.398a19.43 19.43 0 001.94-.552z"
            fill="url(#prefix__BoxAILogo__h)"
            fillOpacity={0.2}
        />
        <path
            d="M9.585 7.665c-2.062-.336-3.591-.04-4.208.833l.002.001c-.759 1.072-.236 3.15 1.431 5.538-.48.513-.925 1.032-1.335 1.553a17.82 17.82 0 01-.876-1.294c-1.723-2.818-2.025-5.287-.85-6.949C4.88 5.74 7.184 5.182 10.252 5.76c-.247.6-.47 1.236-.668 1.905z"
            fill={vars.bdlPurpleRain}
        />
        <path
            d="M9.585 7.665c-2.062-.336-3.591-.04-4.208.833l.002.001c-.759 1.072-.236 3.15 1.431 5.538-.48.513-.925 1.032-1.335 1.553a17.82 17.82 0 01-.876-1.294c-1.723-2.818-2.025-5.287-.85-6.949C4.88 5.74 7.184 5.182 10.252 5.76c-.247.6-.47 1.236-.668 1.905z"
            fill="url(#prefix__BoxAILogo__i)"
            fillOpacity={0.2}
        />
        <path
            d="M11.605 18.998c.473.376.968.752 1.489 1.119h-.002c.808.57 1.61 1.081 2.396 1.536-.721.387-1.439.732-2.144 1.03-.441-.28-.88-.571-1.316-.877a26.398 26.398 0 01-.423-2.808z"
            fill={vars.bdlPurpleRain}
        />
        <path
            d="M11.605 18.998c.473.376.968.752 1.489 1.119h-.002c.808.57 1.61 1.081 2.396 1.536-.721.387-1.439.732-2.144 1.03-.441-.28-.88-.571-1.316-.877a26.398 26.398 0 01-.423-2.808z"
            fill="url(#prefix__BoxAILogo__j)"
            fillOpacity={0.2}
        />
        <path
            d="M8.605 19.048a33.67 33.67 0 01-.131-2.398c-.369.423-.71.846-1.02 1.269.366.38.75.758 1.151 1.13z"
            fill={vars.bdlPurpleRain}
        />
        <path
            d="M8.605 19.048a33.67 33.67 0 01-.131-2.398c-.369.423-.71.846-1.02 1.269.366.38.75.758 1.151 1.13z"
            fill="url(#prefix__BoxAILogo__k)"
            fillOpacity={0.2}
        />
        <path
            d="M26.525 16.412c.32.432.614.864.876 1.294v-.002c1.723 2.818 2.026 5.287.851 6.949-1.133 1.607-3.437 2.165-6.505 1.587-.107-.02-.217-.041-.327-.065l-.084-.02-.084-.019a18.906 18.906 0 01-2.404-.707 25.215 25.215 0 01-2.288-.962 31.681 31.681 0 002.144-1.224 22.45 22.45 0 001.299.48c.674.226 1.316.398 1.92.522.166.034.33.065.492.091 2.062.337 3.591.041 4.208-.832.758-1.073.236-3.15-1.432-5.539A20.512 20.512 0 0023.614 16l-.082-.09a25.002 25.002 0 00-.505-.535 27.508 27.508 0 00-2.632-2.371 32.03 32.03 0 00-3.884-2.656 26.842 26.842 0 00-3.215-1.59 22.61 22.61 0 00-.827-.316c.173-.573.365-1.116.577-1.624.034-.083.07-.164.106-.245a25.193 25.193 0 012.847 1.235 31.094 31.094 0 012.657 1.512c.441.28.88.57 1.316.877l.043.03.043.03a32.785 32.785 0 013.337 2.696c.402.371.785.75 1.15 1.13a23.551 23.551 0 011.98 2.33z"
            fill={vars.bdlPurpleRain}
        />
        <path
            d="M26.525 16.412c.32.432.614.864.876 1.294v-.002c1.723 2.818 2.026 5.287.851 6.949-1.133 1.607-3.437 2.165-6.505 1.587-.107-.02-.217-.041-.327-.065l-.084-.02-.084-.019a18.906 18.906 0 01-2.404-.707 25.215 25.215 0 01-2.288-.962 31.681 31.681 0 002.144-1.224 22.45 22.45 0 001.299.48c.674.226 1.316.398 1.92.522.166.034.33.065.492.091 2.062.337 3.591.041 4.208-.832.758-1.073.236-3.15-1.432-5.539A20.512 20.512 0 0023.614 16l-.082-.09a25.002 25.002 0 00-.505-.535 27.508 27.508 0 00-2.632-2.371 32.03 32.03 0 00-3.884-2.656 26.842 26.842 0 00-3.215-1.59 22.61 22.61 0 00-.827-.316c.173-.573.365-1.116.577-1.624.034-.083.07-.164.106-.245a25.193 25.193 0 012.847 1.235 31.094 31.094 0 012.657 1.512c.441.28.88.57 1.316.877l.043.03.043.03a32.785 32.785 0 013.337 2.696c.402.371.785.75 1.15 1.13a23.551 23.551 0 011.98 2.33z"
            fill="url(#prefix__BoxAILogo__l)"
            fillOpacity={0.2}
        />
        <defs>
            <linearGradient
                id="prefix__BoxAILogo__a"
                x1={3.045}
                y1={25.456}
                x2={30.419}
                y2={10.053}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__b"
                x1={3.045}
                y1={25.456}
                x2={30.419}
                y2={10.053}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__c"
                x1={3.045}
                y1={25.456}
                x2={30.419}
                y2={10.053}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__d"
                x1={3.045}
                y1={25.456}
                x2={30.419}
                y2={10.053}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__e"
                x1={15.952}
                y1={1}
                x2={15.952}
                y2={31}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopOpacity={0} />
                <stop offset={1} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__f"
                x1={15.952}
                y1={1}
                x2={15.952}
                y2={31}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopOpacity={0} />
                <stop offset={1} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__g"
                x1={15.952}
                y1={1}
                x2={15.952}
                y2={31}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopOpacity={0} />
                <stop offset={1} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__h"
                x1={15.952}
                y1={1}
                x2={15.952}
                y2={31}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopOpacity={0} />
                <stop offset={1} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__i"
                x1={28.956}
                y1={23.888}
                x2={1.789}
                y2={10.214}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__j"
                x1={28.956}
                y1={23.888}
                x2={1.789}
                y2={10.214}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__k"
                x1={28.956}
                y1={23.888}
                x2={1.789}
                y2={10.214}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="prefix__BoxAILogo__l"
                x1={28.956}
                y1={23.888}
                x2={1.789}
                y2={10.214}
                gradientUnits="userSpaceOnUse"
            >
                <stop />
                <stop offset={1} stopOpacity={0} />
            </linearGradient>
        </defs>
    </AccessibleSVG>
);

export default BoxAiLogo;
